class MakersFindColorOptions extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('[data-mf-color-image]');
    this.selectedName = this.querySelector('[data-mf-selected-name]');
    this.options = Array.from(this.querySelectorAll('[data-mf-color-option]'));

    this.options.forEach((option, index) => {
      option.addEventListener('click', () => this.select(option));
      option.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  select(option) {
    if (!option || option.classList.contains('is-selected')) return;

    this.options.forEach((item) => {
      const selected = item === option;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-checked', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });

    const colorName = option.dataset.colorName || '';
    const imageUrl = option.dataset.imageUrl || '';
    const imageAlt = option.dataset.imageAlt || colorName;

    if (this.selectedName) this.selectedName.textContent = colorName;
    if (!this.image || !imageUrl) return;

    this.image.classList.add('is-changing');
    const preloader = new Image();
    preloader.onload = () => {
      this.image.src = imageUrl;
      this.image.alt = imageAlt;
      requestAnimationFrame(() => this.image.classList.remove('is-changing'));
    };
    preloader.onerror = () => this.image.classList.remove('is-changing');
    preloader.src = imageUrl;
  }

  onKeydown(event, index) {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.options.length - 1;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.options.length) % this.options.length;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.options.length;

    const nextOption = this.options[nextIndex];
    nextOption.focus();
    this.select(nextOption);
  }
}

if (!customElements.get('makersfind-color-options')) {
  customElements.define('makersfind-color-options', MakersFindColorOptions);
}
